import { render, staticRenderFns } from "./MySecretPrescriptionList.vue?vue&type=template&id=31d39000"
import script from "./MySecretPrescriptionList.vue?vue&type=script&lang=js"
export * from "./MySecretPrescriptionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports